// Base
import Image, { StaticImageData } from 'next/image'

// Packages
import htmr from 'htmr'

// Components
import { Box, Container, Flex, Text } from 'yard-utilities/components'
import MainButton from '@components/v25/ft1/buttons/MainButton'

import SvgBox from '@components/helpers/SvgBox'
import ListItem from '@components/v21/common/list-item/ListItem'

// Icons
import { CheckmarkCircle } from 'icons/v21/Icons'

// Styles
import styles from './InternationalTripWrapper.module.sass'

interface InternationalTripWrapperProps {
  backgroundImage: string | StaticImageData
  title: string
  features: string[]
  redirectURL?: string
  onClick?: () => void
  spacing?: number
}

const InternationalTripWrapper = ({
  backgroundImage,
  title,
  features,
  redirectURL,
  onClick,
  spacing = 0
}: InternationalTripWrapperProps) => {
  return (
    <section>
      <Box
        padding={{ sm: [64, 0] }}
        spacing={{ sm: spacing }}
        className={styles.section}
      >
        <Image
          src={backgroundImage}
          fill
          sizes="(min-width: 1120px) 3000px, 800px"
          placeholder="blur"
          priority
          alt="Beach"
          className={styles.image}
        />
        <Container>
          <Box
            padding={{ sm: [32, 24] }}
            borderRadius={{ sm: [16] }}
            shadow="shadows"
            className={styles.box}
          >
            <Text tagName="h2" variant="title-5" spacing={{ sm: 24 }}>
              {title}
            </Text>
            <Flex
              flexDirection="column"
              rowGap={{ sm: 16 }}
              spacing={{ sm: 32 }}
              className={styles.featuresWrapper}
            >
              {features.map((item, i) => (
                <ListItem
                  key={i}
                  icon={
                    <SvgBox offset={3}>
                      <CheckmarkCircle color="#00B67A" />
                    </SvgBox>
                  }
                  textSize="body-1"
                  fontWeight={400}
                  gap={[8]}
                  position="flex-start"
                >
                  {htmr(item)}
                </ListItem>
              ))}
            </Flex>

            <MainButton
              redirectURL={redirectURL}
              onClick={onClick}
              variant="yellow"
              buttonText="Start & save now"
            />
          </Box>
        </Container>
      </Box>
    </section>
  )
}

export default InternationalTripWrapper
